module.exports = {
      id: "f8db09950cc598975dd7a1bc496eb14bequipment-antenna-wiring.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#f8db09950cc598975dd7a1bc496eb14bequipment-antenna-wiring.svg",
      toString: function () {
        return this.url;
      }
    }